import React from 'react'
import { slugs } from '@/constants/slugs'
import { getProjectStyle, createContactSupportAnswer } from '../shared'
import { GiveawayFaq } from '../types'

export const getSoloMioFaqs = (): GiveawayFaq[] => [
  {
    key: 'releaseDate',
    question: (t) => t('giveawayHowDoIenterSoloMio', 'How do I enter The Solo Mio Lovers Getaway?'),
    answer: (t) => (
      <span className={getProjectStyle(slugs.soloMio)}>
        {t(
          'SoloMioReleaseDateAnswers',
          'Just pre-order tickets to Solo Mio, in theaters February 6th. Each ticket you buy is an entry—and\n' +
            'the more tickets you buy, the more your entries multiply. Buy early for even bigger multipliers. Both\n' +
            'ways boost your chances to win!',
        )}
      </span>
    ),
  },
  {
    key: 'doIneedTickets',
    question: (t) => t('doINeedTicketsQuestion', 'Do I need to buy tickets to enter?'),
    answer: (t) => (
      <span className={getProjectStyle(slugs.soloMio)}>
        {t(
          'doINeedTicketsAnswer',
          'No. While buying tickets is the easiest way to enter, you can also enter by mail without purchase. See the Official Rules for instructions on free entry options.',
        )}
      </span>
    ),
  },
  {
    key: 'giveawayDates',
    question: (t) => t('seniorWhoCanEnter', 'Who can enter?'),
    answer: (t) => (
      <span className={getProjectStyle(slugs.soloMio)}>
        {t(
          'seniorWhoCanEnterAnswer',
          'The giveaway is open to legal residents of the 50 United States (excluding NY and FL) and the\n' +
            'District of Columbia, who are at least the age of majority in their state at the time of entry.',
        )}
      </span>
    ),
  },

  {
    key: 'contactSupport',
    question: (t) => t('contactSupportQuestion', 'How do I contact support?'),
    answer: createContactSupportAnswer(slugs.soloMio),
  },
]
